import script from "./severHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./severHtml.vue?vue&type=script&setup=true&lang=js"

import "./severHtml.vue?vue&type=style&index=0&id=50e5d893&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e5d893"]])

export default __exports__